import { inject, Injector } from '@angular/core';
import { BreadcrumbService, BreadcrumbItem } from './services/breadcrumb.service';

export abstract class BasePage {
  protected injector = inject(Injector);
  protected breadcrumbService = inject(BreadcrumbService);
  protected breadcrumbs: BreadcrumbItem[];

  constructor(breadcrumbs: BreadcrumbItem[]) {
    this.breadcrumbs = breadcrumbs;
    this.updateBreadcrumbs();
  }

  protected updateBreadcrumbs(breadcrumbs?: BreadcrumbItem[]): void {
    this.breadcrumbService.updateBreadcrumbs(breadcrumbs ?? this.breadcrumbs);
  }

  protected addBreadcrumb(breadcrumb: BreadcrumbItem): void {
    this.breadcrumbService.updateBreadcrumbs([...this.breadcrumbs, breadcrumb]);
  }
}
